<script setup lang="ts">
defineProps<{ host: string }>();
</script>

<template>
  <div
    class="flex min-h-screen flex-col items-center justify-center gap-3 bg-background px-6 text-center"
  >
    <h1 class="text-xl font-bold text-white">
      Esta dirección no está configurada
    </h1>
    <p class="max-w-md text-sm text-gray-400">
      No hay ninguna experiencia publicada en
      <span class="font-mono text-gray-200">{{ host }}</span>
      . Si esperabas encontrar una, revisá el dominio con quien te lo compartió.
    </p>
  </div>
</template>
